// extracted by mini-css-extract-plugin
module.exports = {"field":"commonInfo_field__24bch"};